import axios from "axios";

export default {
  obtenerUrlsCanalesTransmision: function(token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/App/ObtenerCanalesTransmision`,
        {},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  }
};
